export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/app.worker.d3f85d59.worker.js");
}
